import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { GlobalErrorHandlerService } from 'src/app/services/global-errors/global-error-handler.service';
import { LeaderboardService } from 'src/app/services/leaderboard/leaderboard.service';
import { AvatarService } from 'src/app/services/lobby/avatar.service';
import { LevelService } from 'src/app/services/lobby/level.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit {
  public contentClass = ''
  public avatars: any[] = [];
  screenName:string;
  
  selectedAvatar:any;
  customer: CustomerModel;

  public error = null;
  nickNameForm: FormGroup;
  nickName: AbstractControl<string>;
  tutorialAvailable: any;
  hasNickname: boolean = false;
  hasAvatar: boolean = false;
  btnDisabled:boolean = false;
  constructor(
    private avatarService: AvatarService,
    private navigator:Navigator,
    private userSessionService:UserSessionService,
    private authService:AuthenticationService,
    private leaderboardService:LeaderboardService,
    private balanceProvider:AccountBalanceService,
    private utils:UtilsService,
    private levelService:LevelService,
    private platform:Platform,
    private globalErrorHandlerService: GlobalErrorHandlerService,
  ) {
    this.screenName = 'avatar';
   
  }

  selectAvatar(avatar){
    this.selectedAvatar = avatar;
  }
  ngOnInit(): void {
    this.contentClass = (this.platform.is('capacitor')) ? "no-scroll" : '';
    this.nickNameForm = new FormGroup({
      nickName: new FormControl('', [Validators.required, Validators.maxLength(20),]),
    });
    this.nickName = this.nickNameForm.get('nickName');

    this.userSessionService.getCustomer().subscribe(customer => {
      this.customer = customer;
      if(this.customer.nickName !== null && !isUndefined(this.customer.nickName)){
        this.nickName.setValue(this.customer.nickName);
        this.hasNickname = true;
      }
      this.avatarService.avatarListSubject.subscribe(res => {
        this.avatars = res;
      });
      if(!this.hasAvatar){
        this.avatarService.getCustomerAvatar(this.customer.customerId).subscribe(res => {
          if(res.payload.avatar){
            this.hasAvatar = true;
            this.selectedAvatar  = res.payload.avatar;
          }else {
            this.selectedAvatar = this.avatars[0];
          }
        })
      }
    })
  }

  setAvatar(){
    this.btnDisabled = true;
    this.error = null;
    if(this.screenName === 'avatar'){
      this.avatarService.setAvatar(this.selectedAvatar.id,this.customer.customerId).subscribe(res => {
        if(!!res){
          this.btnDisabled = false;
          this.userSessionService.refreshCustomer();
          this.screenName = 'nickName';
        
        
        }
        
      }, err => {
        this.btnDisabled = false;
        switch(err.getErrorCode().toUpperCase()){
          case "BAD_CONTENT":
            err.setErrorMessage(err.getErrorMessage());
            break;
        }
        this.error = err;
      })
    }
    if(this.screenName === 'nickName'){
      if(this.nickName.value !== this.customer.nickName) {
        let obj = {
          customer_id: this.customer.customerId,
          nickname : this.nickNameForm.get('nickName').value
        }
        this.authService.callUpdateAccountForNickName(obj).subscribe(res => {
          if(!!res){
  
            this.userSessionService.refreshCustomer();
            this.navigator.dismiss();
            this.launchLBTutorial();
          }
        }, err => {
          this.btnDisabled = false;
          switch(err.getErrorCode().toUpperCase()){
            case "NICKNAME_ALREADY_EXISTS":
              err.setErrorMessage('Nickname already taken, Please try a new one');
              break;
            case "BAD_CONTENT":
              err.setErrorMessage(err.getErrorMessage());
              break;
          }
          this.error = err;
        })
      }else {
        this.navigator.dismiss();
        this.launchLBTutorial();
      }
    }
  }
  launchLBTutorial(){
    // this.userSessionService.getCustomer().subscribe(
    //   (customer: CustomerModel) => {
    //   if (customer) {
    //     this.userSessionService.isAuthenticated().then(isAuth => {
    //       if(isAuth){
            // if (null !== customer.getCustomDataProperty('LB_TUTORIAL_VIEWED')) {
              this.tutorialAvailable = this.customer.getCustomDataProperty('LB_TUTORIAL_VIEWED');  
              if(this.tutorialAvailable === null || this.tutorialAvailable === undefined || this.tutorialAvailable === "false"){
                  this.navigator.navigateTo('LeaderboardTutorialComponent', { customModalClass: 'custom-piggy-model-class-transparent', backdropDismiss: true });
                  this.levelService.setTutorial('LB_TUTORIAL_VIEWED',"true");
              }
            // }
      //     }
      //   })
      // }
    // });
  }

}
